export default __webpack_public_path__ + "static/media/1162.bd696737.png";